// Angular
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';

@Injectable()
export class FunctionsUtilsService {
	/**
	 * Service constructor
	 *
	 * @param snackBar: MatSnackBar
	 * @param dialog: MatDialog
	 */
	constructor(private translate: TranslateService,) {

	 }

	 getDir(){
		return this.translate.currentLang == 'en' ? 'ltr' : 'rtl';
	 }

	 getAllFormErrors(form: FormGroup | FormArray): { [key: string]: any; } | null {
		let hasError = false;
		const result = Object.keys(form.controls).reduce((acc, key) => {
			const control = form.get(key);
			const errors = (control instanceof FormGroup || control instanceof FormArray)
				? this.getAllFormErrors(control)
				: control.errors;
			if (errors) {
				acc[key] = errors;
				hasError = true;
			}
			return acc;
		}, {} as { [key: string]: any; });
		return hasError ? result : null;
	}

	}
